// MODULES
import {
  LocalShipping,
  DirectionsBike,
  Motorcycle,
  DirectionsCar,
} from "@material-ui/icons";
import { useState } from "react";
// PROPS
import { OrderRideProps } from "./order-ride";
// COMPONENTS
import Vehicle from "../app/Vehicle";
import Active from "../app/Active";
import Modal from "../app/Modal";
import ReceiverInfo from "./receiver-info";
import SenderInfo from "./sender-info";
// IMAGES
import wallet from "../../assets/wallet.png";
import visaLogo from "../../assets/visa-logo.png";
import caret from "../../assets/caret-down.png";
import check from "../../assets/check.png";

export default function ShipmentDetails({
  nextDispatchOrderPage,
}: OrderRideProps) {
  const [tab, setTab] = useState<string>("receiver");
  const [paymentModal, setPaymentModal] = useState<boolean>(false);
  const [paymentMethod, setPaymentMethod] = useState<string>("");
  return (
    <div>
      <div className="border h-fit border-border rounded-lg col-span-1">
        <div className="p-5 border-b border-border flex items-center justify-between">
          <div>
            <h1 className="font-semibold text-xl">Shipment details</h1>
          </div>
          <div className="px-3 py-2 rounded-lg bg-themeYellow/10">
            <h1 className="font-medium text-[16px] text-themeYellow">
              Express
            </h1>
          </div>
        </div>
        <div className="p-5">
          <div className="grid grid-cols-3 gap-4">
            <Vehicle>
              <LocalShipping />
              <h1 className="font-semibold text-lg">Trucks</h1>
            </Vehicle>
            <Vehicle>
              <LocalShipping />
              <h1 className="font-semibold text-lg">Pickup</h1>
            </Vehicle>
            <Vehicle>
              <DirectionsBike />
              <h1 className="font-semibold text-lg">Tricycles</h1>
            </Vehicle>
            <Vehicle>
              <Motorcycle />
              <h1 className="font-semibold text-lg">Bike</h1>
            </Vehicle>
            <Vehicle>
              <DirectionsCar />
              <h1 className="font-semibold text-lg">Car</h1>
            </Vehicle>
            <Vehicle>
              <LocalShipping />
              <h1 className="font-semibold text-lg">Vans</h1>
            </Vehicle>
          </div>
          <div className="flex items-center justify-between py-5">
            <div className="flex items-center space-x-2">
              <div className="text-themeText">
                <DirectionsBike fontSize="large" />
              </div>
              <div>
                <h1 className="text-themeGray text-sm font-medium">
                  Estimated amount
                </h1>
                <h1 className="font-semibold text-2xl text-themeText">
                  NGN 1,200.00
                </h1>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <Active />
              <h1 className="font-medium text-themeGray">Available</h1>
            </div>
          </div>
          <div className="mt-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div
                  onClick={() => setTab("receiver")}
                  className={`${
                    tab === "receiver"
                      ? "bg-border/30 p-2 rounded-md text-themeText"
                      : "text-themeGray"
                  } font-semibold text-[16px] cursor-pointer`}
                >
                  <h1>Reciver's info</h1>
                </div>
                <div
                  onClick={() => setTab("sender")}
                  className={`${
                    tab === "sender"
                      ? "bg-border/30 p-2 rounded-md text-themeText"
                      : "text-themeGray"
                  } font-semibold text-[16px] cursor-pointer`}
                >
                  <h1>Sender's info</h1>
                </div>
              </div>
              <div
                onClick={() => setPaymentModal(!paymentModal)}
                className="flex items-center space-x-2 bg-border/30 p-2 rounded-xl cursor-pointer"
              >
                <div>
                  <img src={visaLogo} alt="" className="w-5 h-4" />
                </div>
                <div>
                  <h1 className="text-themeText font-medium">Visa</h1>
                </div>
                <div>
                  <img src={caret} alt="" className="w-4 h-2" />
                </div>
              </div>
            </div>
            <div className="my-5">
              {tab === "receiver" && <ReceiverInfo />}
              {tab === "sender" && <SenderInfo />}
            </div>
          </div>
          <div
            className="bg-primary rounded-lg"
            onClick={nextDispatchOrderPage}
          >
            <button type="submit" className="w-full font-medium">
              Proceed
            </button>
          </div>
        </div>
        <Modal
          openModal={paymentModal}
          setOpenModal={() => setPaymentModal(!paymentModal)}
          header="Payment method"
        >
          <div className="space-y-8 mt-4">
            <div
              className="cursor-pointer flex items-center justify-between"
              onClick={() => setPaymentMethod("wallet")}
            >
              <div>
                <div className="flex items-center space-x-2">
                  <div>
                    <img src={wallet} alt="" className="w-6 h-6" />
                  </div>
                  <div>
                    <h1 className="text-themeText text-lg font-semibold">
                      Zap wallet
                    </h1>
                  </div>
                </div>
                <div>
                  <h1 className="text-themeGray font-medium">NGN 21,000</h1>
                </div>
              </div>
              <div>
                <img
                  src={check}
                  alt=""
                  className={`${
                    paymentMethod === "wallet" ? "opacity-100" : "opacity-0"
                  } duration-500 w-5 h-5`}
                />
              </div>
            </div>
            <div
              className="cursor-pointer flex items-center justify-between"
              onClick={() => setPaymentMethod("card")}
            >
              <div>
                <div className="flex items-center space-x-2">
                  <div>
                    <img src={visaLogo} alt="" className="w-7" />
                  </div>
                  <div>
                    <h1 className="text-themeText text-lg font-semibold">
                      Card
                    </h1>
                  </div>
                </div>
                <div>
                  <h1 className="text-themeGray font-medium">Visa-4535</h1>
                </div>
              </div>
              <div>
                <img
                  src={check}
                  alt=""
                  className={`${
                    paymentMethod === "card" ? "opacity-100" : "opacity-0"
                  } duration-500 w-5 h-5`}
                />
              </div>
            </div>
          </div>
          <div className="px-6">
            <div
              onClick={() => setPaymentModal(!paymentModal)}
              className="absolute bottom-6 w-full px-6 left-0"
            >
              <button className="w-full bottom-6 font-medium">Confirm</button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}
